import { ChatMessagesQuery } from "core/queries";

export default function addAdToChat(content, client, sponsorChatMessage) {
  const query = ChatMessagesQuery;

  const variables = {
    chatRoomId: content.chatRoom.id,
    limit: 30,
  };

  const data = client.readQuery({
    query,
    variables,
  });

  const newChatMessage = {
    id: Date.now(),
    userId: null,
    userDisplayName: null,
    userAvatar: null,
    userIsRightholder: false,
    userIsAdmin: false,
    message: null,
    createdAt: null,
    sponsorChatMessage,
    __typename: "ChatMessage",
  };

  client.writeQuery({
    query,
    variables,
    data: {
      chatMessages: {
        ...data.chatMessages,
        count: data.chatMessages.count + 1,
        nodes: [newChatMessage, ...data.chatMessages.nodes],
      },
    },
  });
}
